import { render, staticRenderFns } from "./questionbankExcel.vue?vue&type=template&id=3aecda4c"
import script from "./questionbankExcel.vue?vue&type=script&lang=js"
export * from "./questionbankExcel.vue?vue&type=script&lang=js"
import style0 from "./questionbankExcel.vue?vue&type=style&index=0&id=3aecda4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports